import React, { useState, useEffect, useRef } from "react";
import { useGetWritingTest } from "../../services";
import Loading from "../layout/Loading";
import { useDroppable } from "@dnd-kit/core";
import { useExam } from "../../context/ExamContext";
import NavigationBar from "../navigation-bar";
import ResizableDivider from "../common/ResizableDivider"; // Import the shared divider
import { useUpdateUserWritingAnswers } from "../../services";
import Header from "../layout/Header";
import { useExamServerDataOperations } from "../../hooks/useExamServerDataOperations";

const Writing = () => {
  const { setNodeRef } = useDroppable({ id: "passage-drop" });
  const { writingTest, isLoadingWritingTest, errorWritingTest } =
    useGetWritingTest();
  const { updateAnswer, writingAnswers, activeQuestion, setActiveQuestion } =
    useExam();

  useExamServerDataOperations();

  const [text, setText] = useState("");
  const [lastSavedWordCount, setLastSavedWordCount] = useState(0);
  const activePage = activeQuestion === 1 ? 0 : 1;
  const updateBulkData = useUpdateUserWritingAnswers();

  // State for dynamic resizing: initial left column width percentage
  const [leftWidth, setLeftWidth] = useState(50);
  const containerRef = useRef(null);

  useEffect(() => {
    setActiveQuestion(1);
  }, [setActiveQuestion]);

  // Only sync text from context when switching between Task 1 / Task 2
  // or on initial load.
  useEffect(() => {
    if (writingTest && writingTest.questions.length > 0) {
      const savedAnswer = writingAnswers.find(
        (a) =>
          a.questionNumber === writingTest.questions[activePage].questionNumber
      )?.answer;
      setText(savedAnswer ?? "");
      setLastSavedWordCount(
        savedAnswer ? savedAnswer.trim().split(/\s+/).length : 0
      );
    }
  }, [writingTest, activePage]);

  // useEffect(() => {
  //   const currentWordCount = text.trim() ? text.trim().split(/\s+/).length : 0;
  //   const wordDiff = Math.abs(currentWordCount - lastSavedWordCount);

  //   if (wordDiff >= 1 && writingTest && writingTest.questions.length > 0) {
  //     updateAnswer({
  //       questionNumber: writingTest.questions[activePage].questionNumber,
  //       answer: text,
  //     });
  //     setLastSavedWordCount(currentWordCount);
  //   }
  // }, [text, lastSavedWordCount, updateAnswer, writingTest, activePage]);


  useEffect(() => {
    if (!writingTest || !writingTest.questions.length) return;

    const timeout = setTimeout(() => {
      updateAnswer({
        questionNumber: writingTest.questions[activePage].questionNumber,
        answer: text,
      });
    }, 300);

    return () => clearTimeout(timeout);
  }, [text, activePage, writingTest, updateAnswer]);


  if (isLoadingWritingTest) return <Loading />;
  if (errorWritingTest) return <div>{errorWritingTest}</div>;

  return (
    <section className="bg-background">
      <Header />

      <div className="p-3 h-[calc(100vh-116px)]">
        {/* <TopBar data={writingTest.passageInstructionLabel} /> */}

        <div
          className="bg-background flex p-2 writing-section"
          ref={containerRef}
          style={{ width: "100%" }}
        >
          <div
            className="p-4 flex question bg-[var(--background-color)]"
            ref={setNodeRef}
            style={{
              flexBasis: `${leftWidth}%`,
              transition: "flex-basis 0.1s ease",
            }}
          >
            {writingTest && writingTest.questions.length > 0 ? (
              <div className="text-lg font-semibold">
                <div
                  dangerouslySetInnerHTML={{
                    __html: writingTest.questions[activePage].label,
                  }}
                />
                {writingTest.questions[activePage].image && (
                  <img
                    src={writingTest.questions[activePage].image}
                    alt="Writing question illustration"
                    className="mt-4 max-w-full h-auto rounded"
                  />
                )}
              </div>
            ) : (
              "No Writing Test Available"
            )}
          </div>

          <ResizableDivider
            containerRef={containerRef}
            leftWidth={leftWidth}
            onWidthChange={setLeftWidth}
          />

          <div
            className="questions-section h-[700px] overflow-hidden flex flex-col"
            style={{
              flexBasis: `${100 - leftWidth}%`,
              transition: "flex-basis 0.1s ease",
            }}
          >
            <textarea
              className="w-full  focus:outline-none border p-4 text-lg flex-1 resize-none overflow-auto bg-[var(--background-color)]"
              placeholder="Write your response here..."
              value={text}
              spellCheck={false}
              onChange={(e) => setText(e.target.value)}
            />
            <div className="text-right mt-2 text-gray-600 flex justify-between items-center">
              <div className="text-[var(--text-color)]">
                Word Count: {text.trim() ? text.trim().split(/\s+/).length : 0}
              </div>
            </div>
          </div>
        </div>
      </div>

      <NavigationBar
        sectionData={writingTest}
        section="writing"
        stageQuestionInterval="1-2"
        updateBulkData={updateBulkData}
      />
    </section>
  );
};

export default Writing;
